import configuration from '../configuration';
import { WebClient } from './web';

const { API_URL, CLIENT_SECRET } = configuration;

export class APIClient extends WebClient {
  constructor() {
    super({ baseURL: API_URL, authenticate: true });

    const forms = ['signin'];
    this.client.interceptors.request.use((request) => {
      if (forms.includes(request.url!)) request.data.secret = CLIENT_SECRET;

      return request;
    });
  }
}

export const API = new APIClient();
